import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form, Row, Col, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { sk } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';

import { exportToPDF, fetchAvailableYears } from '../../store/actions/evidenceList';

const MONTH_LABELS = ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'];
const QUARTER_LABELS = ['Q1 (Jan – Mar)', 'Q2 (Apr – Jún)', 'Q3 (Júl – Sep)', 'Q4 (Okt – Dec)'];

const ExportEvidenceSheetToPdf = ({ onClose, id, branchId }) => {
    const dispatch = useDispatch();
    const years = useSelector(state => state.evidenceList.availableYears);
    const wasteLoading = useSelector(state => state.waste.loading);
    const selectedFilterYear = useSelector(state => state.uiSlice.selectedYear);
    const currentYear = new Date().getFullYear();

    // Načítanie dostupných rokov pri prvom renderovaní komponenty
    useEffect(() => {
        if (branchId) dispatch(fetchAvailableYears({ branchId, evidenceSheetId: id }));
    }, [dispatch, id, branchId, wasteLoading]);

    const [mode, setMode] = useState('year');
    const [year, setYear] = useState(currentYear);
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [quarter, setQuarter] = useState(Math.ceil((new Date().getMonth() + 1) / 3));
    const [day, setDay] = useState(new Date());

    useEffect(() => {
        if (years.length > 0) {
            const defaultYear = years.includes(selectedFilterYear) ? selectedFilterYear : years[years.length - 1];
            setYear(defaultYear);
        }
    }, [years, selectedFilterYear]);

    const reversedYears = [...years].reverse();
    const isButtonDisabled = years.length === 0 || (mode !== 'day' && !year);

    const handleExport = () => {
        const params = { id, branchId, year };
        if (mode === 'day') {
            params.month = day.getMonth() + 1;
            params.day = day.getDate();
            params.year = day.getFullYear();
        } else if (mode === 'quarter') {
            params.quarter = quarter;
        } else if (mode === 'month') {
            params.month = month;
        }
        dispatch(exportToPDF(params));
        onClose();
    };

    return (
        <Form>
            <h2>Exportovať do PDF</h2>
            <hr />

            <Form.Group className="mb-3">
                <Form.Label>Rozsah exportu</Form.Label>
                <div className="d-flex gap-3">
                    {[
                        { value: 'day', label: 'Jeden deň' },
                        { value: 'month', label: 'Mesiac' },
                        { value: 'quarter', label: 'Kvartál' },
                        { value: 'year', label: 'Celý rok' },
                    ].map(({ value, label }) => (
                        <Form.Check
                            key={value}
                            type="radio"
                            id={`evidence-export-mode-${value}`}
                            label={label}
                            checked={mode === value}
                            onChange={() => setMode(value)}
                        />
                    ))}
                </div>
            </Form.Group>

            {mode === 'day' && (
                <Form.Group className="mb-3">
                    <Form.Label>Dátum</Form.Label>
                    <div>
                        <DatePicker
                            selected={day}
                            onChange={(date) => setDay(date)}
                            dateFormat="dd.MM.yyyy"
                            className="form-control"
                            locale={sk}
                        />
                    </div>
                </Form.Group>
            )}

            {mode !== 'day' && (
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Group className="mb-3" controlId="formBasicYear">
                            <Form.Label>Rok</Form.Label>
                            <Form.Select
                                value={year}
                                onChange={(e) => setYear(Number(e.target.value))}
                            >
                                {reversedYears.length > 0 ? (
                                    reversedYears.map((y) => (
                                        <option key={y} value={y}>{y}</option>
                                    ))
                                ) : (
                                    <option disabled>Žiadne roky nie sú k dispozícii</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {mode === 'month' && (
                        <Col xs={12} md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Mesiac</Form.Label>
                                <Form.Select value={month} onChange={(e) => setMonth(Number(e.target.value))}>
                                    {MONTH_LABELS.map((label, index) => (
                                        <option key={label} value={index + 1}>{label}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    )}
                    {mode === 'quarter' && (
                        <Col xs={12} md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Kvartál</Form.Label>
                                <Form.Select value={quarter} onChange={(e) => setQuarter(Number(e.target.value))}>
                                    {QUARTER_LABELS.map((label, index) => (
                                        <option key={label} value={index + 1}>{label}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    )}
                </Row>
            )}

            <Row>
                <Col className="d-flex justify-content-end">
                    <Button
                        className="btn-custom-small"
                        variant="primary"
                        type="button"
                        onClick={handleExport}
                        disabled={isButtonDisabled}
                    >
                        Exportovať do PDF
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default ExportEvidenceSheetToPdf;
